import React from 'react'

import { makeStyles } from 'tss-react/mui'

import { Theme } from '@mui/material'

import { cx } from 'tss-react/@emotion/css'

import { CorporateListViewFilters } from '../../scenes/CorporateListView/CorporateListViewStore'
import { CorporateStatus } from '../../../../../../entities-next/corporate'
import { DebouncedTextFilter } from '../../../../components/DebouncedTextFilter'

import { CorporateStatusSelector } from './CorporateStatusSelector.component'

export type CorporateFiltersProps = {
  className?: string
  filters: CorporateListViewFilters
  onChange: (filters: CorporateListViewFilters) => void
}

export function CorporateFilters({ className, filters, onChange }: CorporateFiltersProps) {
  const { classes } = useStyles()

  const handleIdChange = (id: string) => {
    onChange({ ...filters, id: Number(id) })
  }
  const handleNameChange = (name: string) => {
    onChange({ ...filters, name })
  }
  const handleStatusChange = (newSearch: CorporateStatus) => {
    onChange({ ...filters, status: newSearch })
  }

  return (
    <div className={cx(className, classes.filterList)}>
      <DebouncedTextFilter defaultValue={filters.id?.toString()} placeholder="Id..." onChange={handleIdChange} />
      <DebouncedTextFilter defaultValue={filters.name} placeholder="Name..." onChange={handleNameChange} />
      <CorporateStatusSelector onChange={handleStatusChange} status={filters.status} />
    </div>
  )
}

const useStyles = makeStyles()(({ spacing }: Theme) => ({
  filterList: {
    display: 'flex',
    gap: spacing(2),
  },
}))
